import { App, AppState } from '@capacitor/app';
import { PluginListenerHandle } from '@capacitor/core';
import { useCallback, useEffect, useRef } from 'react';

interface AppStateHookProps {
  foreground?: () => void;
  background?: () => void;
}

const useAppState = (options: AppStateHookProps = {}) => {
  const { foreground, background } = options;

  const listenerRef = useRef<PluginListenerHandle>();

  const handleStateChange = useCallback(
    async (state: AppState) => {
      if (state.isActive) {
        if (foreground) {
          foreground();
        }
      } else {
        if (background) {
          background();
        }
      }
    },
    [background, foreground]
  );

  const setupListener = useCallback(async () => {
    listenerRef.current?.remove();
    listenerRef.current = await App.addListener(
      'appStateChange',
      handleStateChange
    );
  }, [handleStateChange]);

  useEffect(() => {
    setupListener();
    return () => {
      listenerRef.current?.remove();
    };
  }, [handleStateChange, setupListener]);
};

export { useAppState };
